import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    limit: 20,
    page: 1,
    total: 0,
    totalPages: 1,
};

export const promotionalBlockPageSlice = createSlice({
    name: "promotionalBlockPageSlice",
    initialState,
    reducers: {
        setPromotionalBlockPageLimit: (state, action) => {
            state.limit = action.payload;
        },
        setPromotionalBlockCurrentPage: (state, action) => {
            state.page = action.payload;
        },
        setPromotionalBlockTotalCount: (state, action) => {
            state.total = action.payload;
        },
        setPromotionalBlockTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        resetPromotionalBlockPagination: (state, action) => {
            state.limit = 20;
            state.page = 1;
            state.total = 0;
            state.totalPages = 1;
        },
    },
});

export const {
    setPromotionalBlockPageLimit,
    setPromotionalBlockCurrentPage,
    setPromotionalBlockTotalCount,
    setPromotionalBlockTotalPages,
    resetPromotionalBlockPagination,
} = promotionalBlockPageSlice.actions;

export default promotionalBlockPageSlice.reducer;
